import {makeStyles} from "@material-ui/core";

/***
 * 管理者側のレイアウト特定スタイリングはここで行われます
 *
 * @type {(props?: any) => ClassNameMap<"tableHeader"|"navHeaderBackground">}
 */
export const managerCommonStyles = makeStyles((theme) => ({
    tableHeader: {
        backgroundColor: theme.palette.background.dark,
        paddingLeft: 21,
        paddingTop: 13,
        paddingBottom: 13,
        paddingRight: 29,
        "& div": {
            "& p": {
                fontSize: "12px",
                fontWeight: "900",
            }
        }
    },
    navHeaderBackground: {
        backgroundColor: theme.palette.background.navHeader,
        color: "white",
        borderBottom: "1px #CFCFCF solid",
    }
}));


const common = {
    managerCommonStyles
}
export default common;
